import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TankService } from 'src/app/services/tank.service';
import { UserService } from 'src/app/services/user.service';
import { User } from 'src/app/shared/models/User';

@Component({
  selector: 'app-web-access-disabled-page',
  templateUrl: './web-access-disabled-page.component.html',
  styleUrls: ['./web-access-disabled-page.component.css']
})
export class WebAccessDisabledPageComponent implements OnInit {
  currentUser: User;
  tankName: string;

  constructor(
    private userService: UserService,
    private tankService: TankService,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.currentUser = this.userService.currentUser;
    const tank = this.tankService.currentTank;

    if (this.currentUser.role === 'superadmin' || this.tankService.isWebAccessEnabled(tank)) {
      this.router.navigate(['/home']);
      return;
    }

    this.tankName = tank && tank.name ? tank.name : 'este surtidor';
  }

  logout(): void {
    this.userService.logout();
  }
}
